export class SipPiletIconStorage {
  private piletIcon: Record<string, string> = {};

  public getIcon(route: string): string {
    return this.piletIcon[route];
  }

  public setIcon(route: string, piletIcon: string) {
    this.piletIcon[route] = piletIcon;
  }
}
